import { render } from "./OneCocktailBox.vue?vue&type=template&id=264a249a&scoped=true"
import script from "./OneCocktailBox.vue?vue&type=script&lang=js"
export * from "./OneCocktailBox.vue?vue&type=script&lang=js"

import "./OneCocktailBox.vue?vue&type=style&index=0&id=264a249a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264a249a"]])

export default __exports__